import script from "./extra.vue?vue&type=script&setup=true&lang=js"
export * from "./extra.vue?vue&type=script&setup=true&lang=js"

import "./extra.vue?vue&type=style&index=0&id=2af3f39b&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af3f39b"]])

export default __exports__